<template>
    <core-section id="portfolio">
        <Abstract3 />

        <core-heading>{{ $t('portfolio.title') }}</core-heading>

        <v-col cols="12">
            <v-carousel
                :cycle="false"
                :height="height"
                :show-arrows="$vuetify.breakpoint.mdAndUp ? true : false"
                show-arrows-on-hover
                class="elevation-0 carousel-height"
                hide-delimiter-background
            >
                <v-carousel-item v-for="(project, i) in portfolio.projects" :key="i">
                    <Project :value="project" />
                </v-carousel-item>
            </v-carousel>
        </v-col>
    </core-section>
</template>

<script>
export default {
    name: 'Portfolio',

    components: {
        Abstract3: () => import('@/components/Abstract3'),
        Project: () => import('@/components/Project'),
    },

    data() {
        return {
            height: 650,
        };
    },

    computed: {
        portfolio() {
            return this.$i18n.t('portfolio');
        },
    },

    methods: {
        CarouselHeight() {
            if (this.$vuetify.breakpoint.width < 900 && this.$vuetify.breakpoint.width > 700) {
                this.height = 900;
            } else if (this.$vuetify.breakpoint.width > 1200) {
                this.height = 650;
            } else this.height = 700;

            // console.log(this.$vuetify.breakpoint.width, this.height);
        },
    },

    mounted() {
        this.CarouselHeight();
    },
};
</script>
